import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { assetUrl, SkipInterceptorHeader } from './util.service';

@Injectable()
export class CustomTranslateFactoryService implements TranslateLoader {
    contentHeader = new HttpHeaders().set(SkipInterceptorHeader, '');
    response = {};

    constructor(private httpClient: HttpClient) {}

    getTranslation(localization: string): Observable<any> {
      if (localization.indexOf('-') === -1) {
        console.error('Invalid localization');
        return of(null);
      } else {
        const [lang, locale] = localization.split('-');
        return new Observable((observer) => {
          this.downloadTranslation(lang, locale).subscribe(
            (data) => {
              observer.next(data);
            }
          );
        });
      }
  }

  private downloadTranslation(lang: string, locale: string) {
      return forkJoin([
        this.getLanguageFile(lang),
        this.getLocaleFile(locale),
      ]).pipe(
        catchError(error => {
          console.error('Unable to load language files:', lang, locale);
          console.error(error);
          return of(null);
        }),
        map((data: any[]) => {
          if (data && data.length > 0) {
            return { ...data[0], ...data[1] };
          }
          return null;
        })
      );
  }

  private getLanguageFile(lang: string): Observable<any> {
      if (this.response[lang]) {
        return of(this.response[lang]);
      }
      const ts = new Date().getTime().toString();
      return this.httpClient.get(assetUrl(`i18n/${lang}.json?t=${ts}`), { headers: this.contentHeader }).pipe(
        map((data) => {
          this.response[lang] = data;
          return data;
        })
      );
  }

  private getLocaleFile(locale: string) {
      if (this.response[locale]) {
        return of(this.response[locale]);
      }
      const ts = new Date().getTime().toString();
      return this.httpClient.get(assetUrl(`i18n/${locale}.json?t=${ts}`), { headers: this.contentHeader }).pipe(
        map((data) => {
          this.response[locale] = data;
          return data;
        })
      );
  }
}